import { Avatar, Card, Col, Row, Tag, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { PiMapPinFill } from "react-icons/pi";
import "./style.css";
import { useNavigate } from "react-router-dom";
import CarRegistrationNumberPlate from "../../../../../components/Elements/CarRegistrationNumberPlate";
import {
  getBookingStatus,
  getEllipsedString,
  getInitials,
  getServicesList,
} from "../../../../../config/utils";
import { bookingStatusDetails } from "../../../../../config/utils/constants";
import { adminActionIdentifier } from "../../../../../config/utils/StatusIdentifier";

const JobCard = ({ jobData }) => {
  const navigate = useNavigate();
  // PENDING => 0
  // COMPLETED => 1
  // REJECTED => 2
  // ACCEPTED => 3,
  // INPROGRESS => 4
  const jobStatus = bookingStatusDetails;
  const [servicesLength, setServicesLength] = useState(0);

  // If SP has closed the job but backend hasn't updated status to 1 yet,
  // treat it as completed for display purposes
  const effectiveStatus = jobData?.closedBySP ? 1 : jobData?.status;

  useEffect(() => {
    if (jobData) {
      setServicesLength(jobData?.services?.length);
    }
  }, [jobData]);

  return (
    <React.Fragment>
      {jobData && (
        <Card
          bordered={false}
          className="p-0 mb-4 rounded-[17px] border-[#f5f5f5] custom-shadow-none border-[10px]"
          onClick={() => navigate(`/myjobs/${jobData?.id}`)}
        >
          <Row>
            {jobData?.dispute && (
              <Col
                span={24}
                className="mt-[-10px] mb-2 flex items-center justify-end"
              >
                <Tag
                  color={jobData?.dispute?.adminAction ? "success" : "error"}
                  className="m-0"
                >
                  {jobData?.dispute?.adminAction ? "resolved" : "disputed"}
                </Tag>
              </Col>
            )}
            <Col span={6} className="sm:mb-2">
              <Avatar
                className="mr-2"
                src={jobData?.serviceUser?.imageThumbUrl}
                size={60}
              >
                {getInitials(jobData?.serviceUser?.fullName)}
              </Avatar>
            </Col>
            <Col span={18}>
              <Row>
                <Col md={24} sm={24} xs={24}>
                  <div className="mb-4">
                    <div className="flex justify-between">
                      <div className="ml-1">
                        <h5 className="heading-5 font-bold mb-0 mr-4">
                          {getEllipsedString(
                            jobData?.serviceUser?.fullName,
                            10,
                          )}
                        </h5>

                        {jobData?.serviceUser?.badges &&
                        jobData?.serviceUser?.badges.length ? (
                          <div className="flex items-center sm:w-[50px]">
                            {jobData?.serviceUser?.badges.map((badge) => (
                              <img
                                key={badge?.id}
                                src={badge?.imageUrl}
                                alt={badge?.name}
                                className="img-fluid badge w-[30px] inline-block mb-2 mr-2"
                                onError={(e) => {
                                  e.target.style.display = "none";
                                }}
                              />
                            ))}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="flex">
                      <div className="w-[24px]">
                        <PiMapPinFill className="text-primary text-xl" />
                      </div>
                      <small className="ml-1 text-gray-500 font-semibold ellipsis">
                        {jobData?.serviceUser?.address}
                      </small>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col md={24} sm={24} xs={24}>
              {/* previous work */}
              {/* <div>
                                <hr className='border-dashed border-1 border-gray-200 mb-2' />
                                <div className='flex sm:flex-row flex-col'>
                                    {
                                        jobData?.services &&
                                            jobData?.services.length ? (
                                            <React.Fragment>
                                                {
                                                    jobData?.services.slice(0, 2).map((service, index) => (
                                                        <small key={index} className='text-gray-500 text-xs mb-2 font-semibold' >
                                                            {service?.name}

                                                            {index < jobData?.services.slice(0, 2).length - 1 &&
                                                                (<span className='mr-1'>,</span>)}
                                                            {index == 2 && jobData?.services.length > 3 ?
                                                                (<span className='mr-1'>...</span>) : ''}
                                                        </small>
                                                    ))}
                                                {jobData?.services?.length > 2 ? (
                                                    <Tooltip title={getServicesList(jobData?.services)}>
                                                        <p className='text-xs sm:ml-2 cursor-pointer'>show all</p>
                                                    </Tooltip>
                                                ) : ''}
                                            </React.Fragment>
                                        ) : (<small className='text-xs'>Services not available</small>)}
                                </div>
                                // <p className='text-gray-500 font-semibold text-xs mb-3' >{jobData?.details}</p>
                                <hr className='border-dashed border-1 border-gray-200 mb-2' />
                            </div> */}

              {/* updated work */}
              <div>
                <hr className="border-dashed border-1 border-gray-200 mb-2" />
                <div className="flex justify-start my-2 flex-wrap gap-2">
                  {jobData?.services && servicesLength > 0 ? (
                    <React.Fragment>
                      {
                        jobData?.services?.slice(0, 5)?.map((service) => {
                          return (
                            <span className="flex gap-1 items-center justify-start">
                              <p className="text-gray-500 font-semibold text-xs  w-fit text-nowrap">
                                {service.name?.length > 14
                                  ? service.name?.slice(0, 15) + "... ,"
                                  : service.name + ","}
                              </p>
                              {/* <p className='text-gray-500 font-semibold text-xs w-fit text-nowrap'>
                                                                {jobData?.selectedCategories[0].subServices[0]?.name + ' ...'}
                                                            </p> */}
                            </span>
                          );
                        })
                        //         :
                        // <p className='text-center w-full sm:w-fit'>-</p>
                      }
                      {servicesLength > 5 && <span>...</span>}
                      {servicesLength > 5 && (
                        <Tooltip
                          title={getServicesList(jobData?.services, false)}
                        >
                          <p className="text-xs cursor-pointer">show all</p>
                        </Tooltip>
                      )}
                    </React.Fragment>
                  ) : (
                    <small className="text-xs">Services not available</small>
                  )}
                </div>
                <hr className="border-dashed border-1 border-gray-200 mb-2" />
              </div>
              <div className="flex justify-between items-center">
                <div
                  style={{
                    borderColor: effectiveStatus === 1 ? '#00B517' : effectiveStatus === 0 ? '#FAB700' : '#3879F0',
                    color: effectiveStatus === 1 ? '#00B517' : effectiveStatus === 0 ? '#FAB700' : '#3879F0',
                  }}
                  className="flex justify-center items-center border rounded-md px-2 py-1 md:w-2/6 lg:w-2/6 xl:w-2/6 w-2/6 h-[40px]"
                >
                  <span className="text-xs">
                    {jobStatus[effectiveStatus]?.label}
                  </span>
                </div>
                <div className="md:w-3/6 lg:w-2/6 xl:w-2/6 w-2/6">
                  <CarRegistrationNumberPlate
                    regNumber={jobData?.vehicleRegistrationNo}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Card>
      )}
    </React.Fragment>
  );
};

export default JobCard;
